// core
import ButtonModal from './core/ButtonModal'
import Imgix from './core/Imgix'
import Waypoints from './core/Waypoints'
import LightboxGallery from './core/LightboxGallery.js'

// vitals
import SiteVitals from './modules/SiteVitals'

// modules
import Accordion from './modules/Accordion'
import Grid from './modules/Grid'
import Slider from './modules/Slider'
import GravityFormsValidator from './modules/GravityFormsValidator'
import PrimaryNavigation from './modules/PrimaryNavigation'
import OffcanvasStateManager from './modules/OffcanvasStateManager'
import DialogHandler from './modules/Dialog.js'
import HeroHeading from './modules/HeroHeading.js'

// core
new Imgix()
new Waypoints()
new ButtonModal()

// vitals
new SiteVitals()
new PrimaryNavigation()
new OffcanvasStateManager()

// modules
new Accordion();

document.querySelectorAll('.c-hero__heading').forEach(element => {
    new HeroHeading({el: element});
});

document.querySelectorAll('.c-form').forEach(element => {
    new GravityFormsValidator({el: element});
});

document.querySelectorAll("[data-module=lightbox-gallery]").forEach((el) => {
    new LightboxGallery();
})

document.querySelectorAll("[data-module=grid]").forEach((el) => {
    new Grid(el)
})

document.querySelectorAll("[data-module=slider]").forEach((el) => {
    new Slider(el)
})

document.querySelector("#top").addEventListener('click', () => {
    document.documentElement.scrollTop = 0;
});

if (document.querySelector("#dialog")) {
    const dialogContainer = document.getElementById('weather-dialog');

    new DialogHandler(dialogContainer);
}

document.querySelectorAll('.o-media-container__video').forEach(el => {
    el.parentElement.classList.add('paused');

    el.addEventListener("playing", function () {
        el.parentElement.classList.remove('paused');
    });

    el.addEventListener("pause", function () {
        el.parentElement.classList.add('paused');
    });
});

// Select all the grid items
const gridItems = document.querySelectorAll('.c-grid-image__item');

if (gridItems.length > 0) {
    // Create an Intersection Observer instance
    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            const item = entry.target;

            if (entry.isIntersecting) {
                item.classList.add('in-view');
                item.classList.remove('out-of-view');
            } else {
                item.classList.add('out-of-view');
                item.classList.remove('in-view');
            }
        });
        }, {
        threshold: 0.1 // Adjust the visibility threshold as needed
    });

    // Observe each grid item
    gridItems.forEach(item => observer.observe(item));
}

// Prevent esbuild from using either of jQuery or underscore global function names
// as these are both used externally
_ = _.noConflict();
$ = $.noConflict();